<template>
    <el-select v-model="selectedRepairCode" :disabled="preselect === true" class="select" clearable filterable remote :remote-method="searchRepairCodes" :placeholder="$t('common.pleaseSelectRepairCode')" :loading="loading" @change="singleRepairCodeSelected" v-if="!multiple">
        <el-option v-for="item in repairCodes" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-model="selectedRepairCode" class="select" clearable filterable remote :remote-method="searchRepairCodes" :placeholder="$t('common.pleaseSelectRepairCode')" :loading="loading" @change="multiRepairCodeSelected" v-else>
        <el-option v-for="item in repairCodes" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from '../api'
    export default {
        name: 'repair-code-selector',

        props: {
            productId: {
                type: Number
            },
            multiple: {
                type: Boolean,
                default: false
            },
            preselect: {
                default: false
            }
        },
        data() {
            return {
                loading: false,
                selectedRepairCode: undefined,
                repairCodes: []
            }
        },
        methods: {
            searchRepairCodes(term) {
                if (term !== '') {
                    var self = this;
                    self.loading = true
                    api.getRepairCodes(this.productId, term).then(function (response) {
                        self.loading = false
                        self.repairCodes = response.data
                    });
                }
            },
            singleRepairCodeSelected(value) {
                if (value === '') {
                    this.repairCodes = [];
                }
                this.$emit('repair-code-selected', this.repairCodes.find(c => c.id === value));
            },
            multiRepairCodeSelected(value) {
                if (value === '') {
                    this.repairCodes = [];
                }
                this.selectedRepairCode = undefined;
                this.$emit('repair-codes-selected', this.repairCodes.find(c => c.id === value));
            },
            reset() {
                this.selectedRepairCode = undefined;
                this.repairCodes = [];
            }
        },
        watch: {
            preselect: function (val) {
                if (!val) {
                    return
                }
                this.selectedRepairCode = val.id
                this.repairCodes = [val];
            }
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/claims/components/RepairCodeSelector.vue